module.exports = __webpack_public_path__ + "static/media/corporate-services-img96.807942f4.jpg";